export enum ViewMode {
  tablesOnlyMode = 'tablesOnlyMode',
  createMode = 'createMode',
  editMode = 'editMode',
  detailsMode = 'detailsMode',
  insightDetailMode = 'insightDetailMode'
}
